module.exports = __webpack_public_path__ + "static/media/1.7eb0960c.png";